import { formatParams } from '../../../helpers';
import axios from '../axios'
import { ApiController } from './types'

const base = '/users'
const baseToCreate = '/clients'

const apiController: ApiController = {
  getCurrentUser: async () =>
    await axios
      .get(`${base}/me`)
      .then(response => response.data),

  createUser: async (request) =>
    await axios
      .post(baseToCreate, request)
      .then(response => response.data),

  updateUser: async (id: string, request) =>
    await axios
      .patch(`${base}/${id}`, request)
      .then(response => response.data),

  getAdminClients: async () =>
    await axios
      .get(`${base}/clients`)
      .then(response => response.data),

  inviteNewClient: async (request) =>
    await axios
      .post(`${base}/invite`, request)
      .then(response => response.data),

  getUserHead: async (params) => {
    const parameters = formatParams(params);
    return await axios
      .head(`${base}?${parameters}`)
      .then(response => response.data)
  },
  changeUserPassword: async (params) => {
    return await axios
      .post(`${base}/auth/resetPassword`, {
        user: params.user,
        newPassword: params.newPassword

      })
      .then(response => response.data)
  },
  changeUserEmail: async (params) => {
    return await axios
      .put(`${base}/${params.userId}/email`, {
        newEmail: params.email,
      })
      .then(response => response.data)
  },
  sendVerificationEmail: async (authId: string, auth0AppId: string) => {
    return await axios
      .post(`${base}/${authId}/verification?appId=${auth0AppId}`)
      .then(response => response.data)
  },
  resetPasswordRequest: async (params) => {
    const encodedAuthId = encodeURIComponent(params.params.userId)
    return await axios
      .patch(`${base}/auth/${encodedAuthId}/password`, {
        newPassword: params.params.password
      })
      .then(response => response.data)
  }
}

export default apiController
